module.exports = __webpack_public_path__ + "static/ls1-d6c0721c1b5039357770f3fda6ea01f6.png";